import React, { useMemo } from 'react'
import { Body, Button, LinkInline, Subtitle } from '@dasa-health/alma-react'
import { useAppContext } from '@nsw-paginas-deslogadas/store/useAppContext'
import { Images } from '@nsw-paginas-deslogadas/assets'
import * as S from './styles'

const FoldAboutNav: React.FC = () => {
    const { PersonAnalysingWithoutMask } = Images
    const { product } = useAppContext()

    const productLabel = useMemo(() => `Agendar ${product.category?.id === 4 ? 'vacina' : 'exame'}`, [product])

    const dataAtributtes = useMemo(
        () => ({
            'data-item-position': 'O que é?',
            'data-current-service': 'Página de Produto da Marca',
            'data-item-text': productLabel,
        }),
        [productLabel],
    )

    return (
        <S.Container>
            <S.Content>
                <S.Img alt={PersonAnalysingWithoutMask.alt} src={PersonAnalysingWithoutMask.src} />
                <S.Boxes>
                    <S.BoxText>
                        <Subtitle as="h2" size={'md'}>
                            O que é {product.name}?
                        </Subtitle>
                        <Body>{product.productInformation?.description}</Body>
                    </S.BoxText>

                    <S.BoxText>
                        <Subtitle as="h2" size={'md'}>
                            Como é feito?
                        </Subtitle>
                        <Body>{product.productInformation?.method}</Body>
                    </S.BoxText>

                    <S.ButtonsBox>
                        <LinkInline href={product.navigateTo} sx={{ textDecoration: 'none' }} target="_self" {...dataAtributtes}>
                            <Button data-testid="btn-exams">{productLabel}</Button>
                        </LinkInline>
                    </S.ButtonsBox>
                </S.Boxes>
            </S.Content>
        </S.Container>
    )
}
export default FoldAboutNav
